module.exports = __webpack_public_path__ + "static/img/desc.aca69224.png";